module.exports = __webpack_public_path__ + "media/images/placeholders/beistandschaften-11294bf5b621f176c1e75b78479e45a7.jpg";